import { Widgets } from '@modules/common/constants';
import { useGetFeedWhereClause } from '@modules/feed/hooks';
import { useGetFeedDuration } from '@modules/feed/hooks/useGetFeedDuration';
import { useMemo } from 'react';
import { EmptyWhereClause } from 'v2/core/services/queryBuilder/whereClause';
import { getUseInQuantifyV2Link } from '../utils';

interface useGetTrendingReasonsLinkForQuantifyOptions {
  shouldShowCooccurringDataPoints?: boolean;
}

export const useGetTrendingReasonsLinkForQuantify = ({
  shouldShowCooccurringDataPoints,
}: useGetTrendingReasonsLinkForQuantifyOptions) => {
  const duration = useGetFeedDuration();
  const whereClause = useGetFeedWhereClause();

  const quantifyLink = useMemo(() => {
    return getUseInQuantifyV2Link({
      duration,
      shouldShowCooccurringDataPoints,
      whereClause: whereClause ?? EmptyWhereClause,
      widget: Widgets.Reason,
    });
  }, [duration, whereClause, shouldShowCooccurringDataPoints]);

  return quantifyLink;
};
